var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveEditor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.2485 12.5428C7.0245 12.5428 6.8005 12.4572 6.6295 12.285L4.2565 9.89505C3.9145 9.55062 3.9145 8.99267 4.2565 8.64924C4.5985 8.3048 5.1515 8.3038 5.4935 8.64823L7.2485 10.4157L11.3765 6.25833C11.7185 5.91389 12.2715 5.91389 12.6135 6.25833C12.9555 6.60276 12.9555 7.16071 12.6135 7.50515L7.8675 12.285C7.6965 12.4572 7.4725 12.5428 7.2485 12.5428Z",
    className: "fill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveEditor);
export default __webpack_public_path__ + "static/media/save-editor.6d8cea6ad8f98de4f6d66758900c4621.svg";
export { ForwardRef as ReactComponent };